import Breadcrumb from "components/common/Breadcrumb/Breadcrumb";
import Header from "components/common/Header/Header";
import AvatarGroup from "components/common/Avatar/AvatarGroup";
import SideBarNew from "components/common/SideBar/SideBarNew";
import {
  REPORTING_BREADCRUMB,
  REPORTING_BREADCRUMB_PAGES,
} from "Constants/BreadcrumbConstant";
import { LoginContext } from "helpers/LoginContext";
import React, { useContext, useEffect, useState } from "react";
import PaginationComponent from "components/common/Pagination/index";
import {
  DOC_DOWNLOAD_URL,
  emptyPaginationObj,
  REPORTING_LIMIT,
  SORT_TYPE,
  getParticipantLabel,
} from "Constants/constant";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import TableHeader from "components/common/Table/TableHeader";
import { apiPostRequest,apiGetRequest } from "helpers/Requests";
import { URL_REPORTING_FEEDBACK_REPORTS } from "store/services/URL";
import moment from "moment";
import { toast } from "react-toastify";
import { addMonths, exportTOExcel, truncateTextReporting,capitalizeWords } from "Utils/utils";
import useReportExport from "../useReportExport";
import { withReportSortOnUrl } from "../reportExportUtils";
import PopoverContainer from "components/common/Popover/PopoverContainer";
import FeedbackFilters from "./components/FeedbackReportFilters";
import {
  ReportFiltersShell,
  ReportPageContent,
  ReportTableSection,
} from "../reportFilterUi";
import {URL_FEEDBACK_MANAGERS_LIST, URL_FEEDBACK_WORKER_LIST } from "store/services/URL";


const getStatusColorClass = (status) => {
  const statusLower = status?.toLowerCase();
  if (statusLower === 'completed' || statusLower === 'complete') {
    return 'bg-green-100 text-green-800 border border-green-200';
  }
  if (statusLower === 'pending') {
    return 'bg-yellow-100 text-yellow-800 border border-yellow-200';
  }
  if (statusLower === 'in_progress') {
    return 'bg-blue-100 text-blue-800 border border-blue-200';
  }
  return 'bg-gray-100 text-gray-800 border border-gray-200';
};

const FeedbackReports = (props) => {
  const { settings } = props;
  const participantLabelPlural = getParticipantLabel(settings?.care_sector, true);
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);

  const [search, setSearch] = useState (null);

  const [reportList, setReports] = useState(null);
  const [loader, setLoader] = useState(false);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [page, setPage] = useState(1);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);


  const [isInitialRender, setIsInitialRender] = useState(true);
  const { runExport, QueuedModal, getExportSortFilters } = useReportExport(
    "feedback_report",
    "Feedback Report",
    { sortBy, sortDescending }
  );
  const [isDisableSearch, setIsDisableSearch] = useState(false);


  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [selectedManager, setSelectedManager] = useState(null);
  const [selectedWorker, setSelectedWorker] = useState(null);

  const [statusOptions] = useState([
    { label: "Pending", value: "pending" },
    { label: "In Progress", value: "in_progress" },
    { label: "Completed", value: "completed" }
  ]);
  const [participantOptions, setParticipantOptions] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  const [workerOptions, setWorkerOptions] = useState([]);

  const [loadingParticipants, setLoadingParticipants] = useState(false);
  const [loadingManagers, setLoadingManagers] = useState(false);
  const [loadingWorkers, setLoadingWorkers] = useState(false);
  const [selectedFromDate, setSelectedFromDate] = useState(null);

  useEffect(() => {
    if (isInitialRender) {
      setIsInitialRender(false);
      return;
    }

    fetchListReports();
  }, [page]);



  useEffect(() => {
    loadParticipants();
    loadManagers();
    loadWorkers();
  }, []);



  const loadParticipants = async () => {
    if (loadingParticipants || participantOptions.length > 0) return;

    setLoadingParticipants(true);
    try {
      const response = await apiGetRequest("/sp/feedback/participants_list");
      if (response?.status === 200) {
        const formattedParticipants = response?.data?.data?.map((participant) => ({
          id: participant?.id,
          value: participant?.uuid || '',
          label: participant?.first_name + " " + participant?.last_name || '',
        })).sort((a, b) => a.label.localeCompare(b.label));
        setParticipantOptions(formattedParticipants || []);
      }
    } catch (error) {
      console.error('Error loading participants:', error);
      setParticipantOptions([]);
    } finally {
      setLoadingParticipants(false);
    }
  };

  const loadManagers = async () => {
    if (loadingManagers || managerOptions.length > 0) return;

    setLoadingManagers(true);
    try {
      const response = await apiGetRequest(URL_FEEDBACK_MANAGERS_LIST);
      if (response?.status === 200) {
        const formattedManagers = response?.data?.data?.map(manager => ({
          id: manager?.user?.id,
          uuid: manager?.user?.uuid,
          value: manager?.user?.email || manager?.user?.id,
          label: `${manager?.user?.name}`,
        })).sort((a, b) => a.label.localeCompare(b.label));
        setManagerOptions(formattedManagers || []);
      }
    } catch (error) {
      console.error('Error loading managers:', error);
      setManagerOptions([]);
    } finally {
      setLoadingManagers(false);
    }
  };

  const loadWorkers = async () => {
    if (loadingWorkers || workerOptions.length > 0) return;

    setLoadingWorkers(true);
    try {
      const response = await apiGetRequest(URL_FEEDBACK_WORKER_LIST);
      if (response?.status === 200) {
        const formattedWorkers = response?.data?.data?.map((worker) => ({
          id: worker?.id,
          value: worker?.uuid || worker?.id,
          label: `${worker?.first_name || ''} ${worker?.last_name || ''}`.trim() || worker?.name,
        })).sort((a, b) => a.label.localeCompare(b.label));
        setWorkerOptions(formattedWorkers || []);
      }
    } catch (error) {
      console.error('Error loading workers:', error);
      setWorkerOptions([]);
    } finally {
      setLoadingWorkers(false);
    }
  };

  const fetchListReports = async (
    isClearAll = false,
    report = null,
    filters = null
  ) => {
    if (!fromDate && !toDate) {
      toast("Select create date range to get data");
      return;
    }

    setLoader(true);
    let url = `${URL_REPORTING_FEEDBACK_REPORTS}?per_page=25&page=${page}`;
    url = withReportSortOnUrl(url, filters || {}, sortBy, sortDescending);
    const payload = {
      search: search ? search : "",

      date_range: isClearAll
        ? "all"
        : toDate && fromDate
        ? [fromDate, toDate]
        : "all",
      type: "feedback",
    };

    if (selectedStatus) {
      payload.status = selectedStatus?.value;
    }
    if (selectedParticipant) {
      payload.participant_name = selectedParticipant?.label;
    }
    if (selectedManager) {
      payload.manager_name = selectedManager?.label;
    }
    if (selectedWorker) {
      payload.worker_name = selectedWorker?.label;
    }
    if (report) {
      await runExport({
        format: report,
        payload,
        syncUrl: url,
        filters: filters || {},
        totalRows: paginationObj?.total,
        setLoader,
        onSyncExcel: exportTOExcelFile,
        onSyncPdf: (downloadUrl) => window.open(downloadUrl, "_blank"),
      });
      return;
    }
    await apiPostRequest(url, payload)
      .then((res) => {
        if (res.status === 200) {
          setLoader(false);
          setReports(res?.data?.data);
          setPaginationObj((prev) => ({
            ...prev,
            total: res?.data?.data?.feedbackAndComplaints?.total,
            totalPages: Math.ceil(
              res?.data?.data?.feedbackAndComplaints?.total /
                res?.data?.data?.feedbackAndComplaints?.per_page
            ),
          }));
        }
      })
      .catch((error) => {
        toast.error(`${error}`);
        console.log({ error });
        setLoader(false);
      });
  };
  const handleFileDownLoad = (e) => {
    fetchListReports(false, e, getExportSortFilters());

    // if (e === "xlsx") {
    //   exportTOExcelFile();
    // } else {
    //   fetchListReports(false, e);
    // }
  };

  const exportTOExcelFile = (reportData) => {
    const transformedData =
      reportData &&
      reportData.feedbackAndComplaints &&
      reportData?.feedbackAndComplaints?.map((item) => {
        return {
          Feedback_ID: item?.uuid ? item.uuid.substring(0, 8).toUpperCase() : 'N/A',
          Subject: item?.subject || 'N/A',
          Submitted_By: item?.created_by?.name || 'N/A',
          Status: item?.status?.toLowerCase() === 'in_progress'
            ? 'In Progress'
            : item?.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : 'N/A',
            Date: moment(item?.date).format("DD/MM/YYYY"),
          [participantLabelPlural]: item?.participants?.map(p => p.name).join(', ') || 'N/A',
          Managers: item?.mention_managers?.map(m => m?.name).join(', ') || 'N/A',
          Workers: item?.workers?.map(w => w.name).join(', ') || 'N/A'
        };
      });
    if (
      !transformedData ||
      transformedData === undefined ||
      transformedData?.length === 0
    ) {
      toast("No data found!");
      return;
    }

    exportTOExcel(transformedData);
  };

  const handleFetch = (obj) => {
    fetchListReports(false, null, { ...obj });
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  const handleStatusChange = (option) => {
    setSelectedStatus(option);
  };

  const handleParticipantChange = (option) => {
    setSelectedParticipant(option);
  };

  const handleManagerChange = (option) => {
    setSelectedManager(option);
  };

  const handleWorkerChange = (option) => {
    setSelectedWorker(option);
  };

  const handleDateRangeChange = (obj) => {
    if (obj) {
      obj.fromDate && setFromDate(obj.fromDate);
      obj.toDate && setToDate(obj.toDate);
    }
  };

  const handleDateCancel = () => {
    setFromDate(null);
    setToDate(null);
    setReports([]);
  };

  const handleClearAllFilters = () => {
    setSearch(null);
    setSelectedStatus(null);
    setSelectedParticipant(null);
    setSelectedManager(null);
    setSelectedWorker(null);
    setFromDate(null);
    setToDate(null);
    setSelectedFromDate(null);
    setReports([]);
  };

  return (
    <div className='min-h-full'>
      <SideBarNew />
      <div
        className={`${
          sideBarPadding ? "lg:pl-[4rem] duration-300" : "lg:pl-64 duration-300"
        }  flex flex-col `}
      >
        <main className='flex-1 bg-gray-50 min-h-screen'>
          <Header
            title='Feedback Reports'
            breadcrumb={
              <Breadcrumb
                pages={REPORTING_BREADCRUMB(
                  REPORTING_BREADCRUMB_PAGES.FEEDBACK_REPORTS
                )}
              />
            }
          />
          <ReportPageContent>
            <ReportFiltersShell>
                <FeedbackFilters
                      selectedStatus={selectedStatus}
                      selectedParticipant={selectedParticipant}
                      selectedManager={selectedManager}
                      selectedWorker={selectedWorker}
                      fromDate={fromDate}
                      toDate={toDate}
                      statusOptions={statusOptions}
                      participantOptions={participantOptions}
                      managerOptions={managerOptions}
                      workersList={workerOptions}
                      search={search}
                      setSearch={setSearch}
                      onStatusChange={handleStatusChange}
                      onParticipantChange={handleParticipantChange}
                      onManagerChange={handleManagerChange}
                      handleWorkerChange={handleWorkerChange}
                      onDateRangeChange={handleDateRangeChange}
                      onDateCancel={handleDateCancel}
                      onClearAllFilters={handleClearAllFilters}
                      participantLabel={getParticipantLabel(settings?.care_sector, false)}
                      participantLabelPlural={participantLabelPlural}
                      loadingManagers={loadingManagers}
                      loadingWorkers={loadingWorkers}

                      fetchListReports={fetchListReports}
                      loader={loader}
                      isDisableSearch={isDisableSearch}
                      setReports={setReports}
                      setFromDate={setFromDate}
                      setToDate={setToDate}
                      selectedFromDate={selectedFromDate}
                      setSelectedFromDate={setSelectedFromDate}
                      setSelectedStatus={setSelectedStatus}
                      setSelectedParticipant={setSelectedParticipant}
                      setSelectedManager={setSelectedManager}
                      setSelectedWorker={setSelectedWorker}
                      isUserGracePeriodOver={isUserGracePeriodOver}
                      handleFileDownLoad={handleFileDownLoad}
                    />
            </ReportFiltersShell>
            <ReportTableSection>
                <table className='border min-w-full divide-y divide-gray-300'>
                  <thead
                    // style={{ top: "130px" }}
                    className='bg-gray-50 sticky z-[5]'
                  >
                    <tr>
                      <TableHeader
                        sortName='uuid'
                        flipSort={flipSort}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        label={"Feedback ID"}
                        cssClass='bg-blue-50 pl-4'
                      />

                      <TableHeader
                        sortName='subject'
                        label={"Subject"}
                        cssClass='bg-blue-50 px-0'
                      />
                       <TableHeader
                        label={"Submitted By"}
                        cssClass='bg-blue-50 px-0'
                      />
                      <TableHeader
                        label={"Status"}
                        cssClass='bg-blue-50 px-0'
                      />

                      <TableHeader
                        label={"Date"}
                        cssClass='bg-blue-50 px-0'
                      />
                      <TableHeader
                        label={participantLabelPlural}
                        cssClass='bg-blue-50 px-0'
                      />
                       <TableHeader
                        label={"Manager(s)"}
                        cssClass='bg-blue-50 px-0'
                      />
                      <TableHeader
                        label={"Worker(s)"}
                        cssClass='bg-blue-50 px-0'
                      />
                    </tr>
                  </thead>
                  <tbody className='divide-y divide-gray-200 bg-white'>
                    {loader ? (
                      <tr className='bg-white'>
                        <td colSpan={8} className='py-6 text-center bg-white'>
                          <div
                            className={`flex flex-col w-full min-h-screen  items-center justify-start`}
                          >
                            <CircularLoader
                              classes='flex justify-center items-center'
                              classloader='loader-l'
                            />
                          </div>
                        </td>
                      </tr>
                    ) : reportList !== null &&
                      reportList?.feedbackAndComplaints?.data?.length > 0 ? (
                      reportList?.feedbackAndComplaints?.data?.map(
                        (singleFeedback, index) => (
                          <tr
                            key={index}
                            className='even:bg-white odd:bg-gray-50'
                          >
                            <td className='whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900'>
                              <div className='truncate flex space-x-4 items-center'>
                                {singleFeedback?.uuid ? singleFeedback.uuid.substring(0, 8).toUpperCase() : 'N/A'}
                              </div>
                            </td>

                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                              <div
                                className='font-medium whitespace-nowrap overflow-hidden text-gray-900 capitalize'
                                style={{
                                  maxWidth: "200px",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {singleFeedback?.subject ? (
                                  <PopoverContainer
                                    cssClass={`text-white text-sm bg-gradient p-2 rounded-md z-10`}
                                    itemComponent={() => {}}
                                    toolTip={`${singleFeedback?.subject}`}
                                  >
                                    <span>
                                      {truncateTextReporting(
                                        singleFeedback?.subject
                                      )}
                                    </span>
                                  </PopoverContainer>
                                ) : (
                                  "-"
                                )}
                              </div>
                            </td>

                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                                {singleFeedback?.created_by?.name || 'N/A'}
                            </td>

                            <td className='whitespace-nowrap px-3 py-4 text-sm'>
                              <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full capitalize ${getStatusColorClass(singleFeedback?.status)}`}>
                                {singleFeedback?.status?.toLowerCase() === 'in_progress'
                                  ? 'In Progress'
                                  : singleFeedback?.status ? singleFeedback.status.charAt(0).toUpperCase() + singleFeedback.status.slice(1) : 'N/A'}
                              </span>
                            </td>

                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                              {singleFeedback?.date
                                ? moment(singleFeedback?.date).format(
                                    "DD/MM/YYYY"
                                  )
                                : "-"}
                            </td>

                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                              <div className='flex items-center'>
                                {singleFeedback?.participants && singleFeedback?.participants.length > 0 ? (
                                  singleFeedback?.participants.length === 1 ? (
                                    <span className='truncate whitespace-nowrap overflow-ellipsis block'>
                                      {capitalizeWords(singleFeedback?.participants[0]?.name || 'N/A')}
                                    </span>
                                  ) : (
                                    <AvatarGroup
                                      arrayData={singleFeedback?.participants?.map(participant => ({
                                        ...participant,
                                        first_name: participant?.name?.split(' ')[0] || '',
                                        last_name: participant?.name?.split(' ').slice(1).join(' ') || ''
                                      }))}
                                      cssClass='mt-0'
                                      maxLength={3}
                                      isNoRing={true}
                                    />
                                  )
                                ) : (
                                  <span className='text-gray-400'>No {participantLabelPlural.toLowerCase()}</span>
                                )}
                              </div>
                            </td>

                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                                {singleFeedback?.mention_managers && singleFeedback?.mention_managers.length > 0 ? (
                                    singleFeedback?.mention_managers.length === 1 ? (
            <>
              <span className='truncate whitespace-nowrap overflow-ellipsis block'>
                {singleFeedback?.mention_managers[0]?.name || 'N/A'}
              </span>
            </>
          ) : (
            <AvatarGroup
              arrayData={singleFeedback?.mention_managers?.map(manager => ({
                ...manager,
                first_name: manager?.name?.split(' ')[0] || '',
                last_name: manager?.name?.split(' ').slice(1).join(' ') || ''
              }))}
              cssClass='mt-0'
              maxLength={3}
              isNoRing={true}
            />
          )
        ) : (
          <span className='text-gray-400'>No managers</span>
        )}
                            </td>

                            <td className='whitespace-nowrap px-3 text-left py-4 text-sm text-gray-500'>
                              <div className='flex items-center'>
                                {singleFeedback?.workers && singleFeedback?.workers.length > 0 ? (
                                  singleFeedback?.workers.length === 1 ? (
                                    <span className='truncate whitespace-nowrap overflow-ellipsis block'>
                                      {capitalizeWords(singleFeedback?.workers[0]?.name || 'N/A')}
                                    </span>
                                  ) : (
                                    <AvatarGroup
                                      arrayData={singleFeedback?.workers?.map(worker => ({
                                        ...worker,
                                        first_name: worker?.name?.split(' ')[0] || '',
                                        last_name: worker?.name?.split(' ').slice(1).join(' ') || ''
                                      }))}
                                      cssClass='mt-0'
                                      maxLength={3}
                                      isNoRing={true}
                                    />
                                  )
                                ) : (
                                  <span className='text-gray-400'>No workers</span>
                                )}
                              </div>
                            </td>
                          </tr>
                        )
                      )
                    ) : (
                      <tr>
                        <td
                          colSpan={8}
                          className='py-6 text-center text-red-600'
                        >
                          No data found. Please adjust your filters to get
                          relevant results
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
            </ReportTableSection>

              {reportList &&
                reportList?.feedbackAndComplaints?.data?.length > 0 && (
                  <div className='mt-3'>
                    <PaginationComponent
                      page={paginationObj?.page || 1}
                      activeListLength={
                        reportList?.feedbackAndComplaints?.data || []
                      }
                      limit={REPORTING_LIMIT}
                      totalList={paginationObj?.total}
                      handlePagination={(e) => {
                        setPage(e);
                        const obj = paginationObj;
                        obj.page = e;
                        setPaginationObj({ ...obj });
                      }}
                      totalPages={paginationObj?.totalPages}
                    />
                  </div>
                )}
          </ReportPageContent>
        </main>
      </div>
      <QueuedModal />
    </div>
  );
};

export default FeedbackReports;
